import { render } from "./questionQuote.vue?vue&type=template&id=875521fa"
import script from "./questionQuote.vue?vue&type=script&lang=js"
export * from "./questionQuote.vue?vue&type=script&lang=js"

import "./questionQuote.vue?vue&type=style&index=0&id=875521fa&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__